import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  selector: 'email-verification-url-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './verification-url.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class VerificationUrlTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<VerificationUrlTemplateData>;
}

export type VerificationUrlTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
  p2: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const VerificationUrlTemplateMocks: VerificationUrlTemplateData[] = [
  {
    title: 'Hello Olivia 👋',
    p1: 'Thanks for joining Recruitee! Please click the link below to verify your account.',
    p2: "If you didn't create an account with Recruitee, please ignore this email.",
    button_link: 'http://recruitee.com',
    button_text: 'Verify account now',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
